import { printQuery } from '../services/utils/print-query';

type Fetch<T> = Omit<Response, 'json'> & {
    json: () => Promise<T>;
};

type ParamType = {
    [key: string]: string;
};

/**
 * Helper method for fetching content from the API
 */
export async function fetcher<T>(
    endpoint: string,
    params: ParamType = {},
    headers: HeadersInit = {},
    opts: RequestInit = {}
): Promise<Fetch<T>> {
    const url = params ? `${endpoint}?${new URLSearchParams(params).toString()}` : endpoint;

    printQuery(url, headers);

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            ...headers,
            'Content-Type': 'application/json; charset=utf-8',
        },
        ...opts,
    });

    const { status, statusText } = response;

    if (status >= 500) {
        console.error(`Failed to fetch API with url:${url}`);
        console.error(statusText);
    }

    return response;
}
